module.exports = __webpack_public_path__ + "static/media/HowToAdbop_Desktop_EN_2.5549de56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HowToAdbop_Desktop_EN_2.png
// module id = 582
// module chunks = 0